export default __webpack_public_path__ + "static/media/p4.63ed1ee2.png";